import script from "./ProgramDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramDetail.vue?vue&type=style&index=0&id=30d8b7e6&lang=scss"

const __exports__ = script;

export default __exports__